export default (wrapper: Element) => {
    const input: HTMLInputElement | null = wrapper.querySelector("input[type=file]");
    const placeholder: HTMLElement | null = wrapper.querySelector(".file-upload--placeholder");
    const content: HTMLElement | null = wrapper.querySelector(".file-upload--content");
    const filesList: HTMLUListElement | null = wrapper.querySelector(".file-upload--content--list");
    const removeButton: HTMLElement | null = wrapper.querySelector(".file-upload--content--remove-btn");

    if (!input || !placeholder || !content || !removeButton || !filesList) {
        console.error("Uncomplete HTML construct for file uploader!");
        return;
    }

    const removeUpload = () => {
        filesList.innerHTML = '';
        content.style.display = "none";
        placeholder.style.display = "block";
        wrapper.classList.remove("has-file");
        input.files = null;
        input.value = "";
    };
    const onFileChanged = () => {
        if (input.files && input.files.length > 0) {
            let items: string = '';
            for (let i = 0; i < input.files.length; i++) {
                items += '<li class="item"><span class="name">' + input.files.item(i).name + '</span></li>';
            }
            filesList.innerHTML = items;
            placeholder.style.display = "none";
            content.style.display = "block";
            wrapper.classList.add("has-file");
        } else {
            removeUpload();
        }
    };
    const preventDefault = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    input.addEventListener("dragover", () => {
        wrapper.classList.add("image-dropping");
    });
    input.addEventListener("dragleave", () => {
        wrapper.classList.remove("image-dropping");
    });
    input.addEventListener("drop", () => {
        wrapper.classList.remove("image-dropping");
    });
    input.addEventListener("change", onFileChanged);
    input.addEventListener("drag", preventDefault);
    input.addEventListener("dragstart", preventDefault);
    input.addEventListener("dragenter", preventDefault);
    removeButton.addEventListener("click", removeUpload);
    onFileChanged();
}